module.exports = __webpack_public_path__ + "img/15_22.325208b3.png";